// Stage enum for environment-based routing
export enum Env {
  dev = 'DEV',
  staging = 'STAGING',
  prod = 'PROD',
}

/**
 * Next.js App Router paths
 * These routes are handled by Next.js and should use client-side navigation.
 * Other routes (WordPress) should use full page navigation for performance.
 *
 * Based on /apps/webapp/src/app folder structure:
 * - /
 * - /about-us
 * - /brand/[brandName]
 * - /checkout
 * - /collections/[...slug]
 * - /collections/skinseoulselects
 * - /contact-us
 * - /my-account
 * - /my-account/loyalty
 * - /product/[slug]
 * - /product-tag/[tagSlug]
 * - /return-refund-exchange-policy
 * - /search
 * - /shop
 */
const NEXT_ROUTING_PATHS: RegExp[] = [
  /^\/$/, // Home
  /^\/about-us(\/)?$/, // About Us
  /^\/brand\/[^/]+(\/)?$/, // Brand detail: /brand/[brandName]
  /^\/checkout(\/)?$/, // Checkout
  /^\/collections(\/.*)?$/, // Collections (catch-all): /collections/[...slug]
  /^\/my-account\/.+$/, // My Account (and nested routes)
  /^\/product\/[^/]+(\/)?$/, // Product detail: /product/[slug]
  /^\/product-tag\/[^/]+(\/)?$/, // Product tag: /product-tag/[tagSlug]
  /^\/search(\/)?$/, // Search
  /^\/shop(\/)?$/, // Shop
];

/**
 * Map of Next.js routing paths by environment
 * Currently all environments use the same routes
 */
export const NEXT_ROUTING_PATH_REGEXS: Map<Env, RegExp[]> = new Map([
  [Env.dev, NEXT_ROUTING_PATHS],
  [Env.staging, NEXT_ROUTING_PATHS],
  [Env.prod, NEXT_ROUTING_PATHS],
]);
